(function () {
    var vm = this;

    // 默认sweetAlert配置
    var defaultSweetConfig = {
        // 标题
        title: "",
        // 文本内容
        text: "",
        //warning error info success question
        type: "",
        // 是否反向显示confirm和取消按钮
        reverseButtons: true,
        // 是否显示取消按钮
        showCancelButton: false,
        // 确认按钮的颜色
        confirmButtonColor: '#4098db',
        // 确认按钮上的文本
        confirmButtonText: 'OK',
        // 确认按钮的自定义class类
        confirmButtonClass: 'alert-prompt__confirm-btn',
        // 取消按钮上的文本
        cancelButtonText: 'Cancel',
        // 取消按钮的颜色
        cancelButtonColor: '#dadada',
        // 取消按钮的自定义class类
        cancelButtonClass: 'alert-prompt__cancel-btn',
        // 为按钮添加默认的swal2样式
        buttonsStyling: true,
        // 是否允许点击对话框外部来关闭对话框
        allowOutsideClick: false,
        // 是否允许按下Esc键来关闭对话框
        allowEscapeKey: false
    };

    vm.__outPutApi = {
        // 确认和关闭按钮可用
        enableButtons: swal.enableButtons,
        // 禁用确认和关闭按钮
        disableButtons: swal.disableButtons
    }

    function argumentTransform(argObj) {
        var argList = [];
        for (var key in argObj) {
            argList.push(argObj[key]);
        }
        return argList;
    }

    // 调用SweetAlert控件方法
    function callSweetAlert(config, confirmCallback, cancelCallback) {
        swal(config).then(function (isConfirm) {
            if (isConfirm.value === true) {
                if (!confirmCallback) {
                    return;
                }
                vm.confirmOperation(confirmCallback);
            } else {
                if (!cancelCallback) {
                    return;
                }
                vm.cancelOperation(cancelCallback);
            }
        })
    }


    // 执行确定操作
    vm.confirmOperation = function (confirmOperation) {
        if (!confirmOperation.fn) {
            return;
        }
        // 将参数对象转为数组
        var argList = argumentTransform(confirmOperation.arguments);
        confirmOperation.fn.apply(vm, argList);
    }
    // 执行取消操作
    vm.cancelOperation = function (cancelOperation) {
        if (!cancelOperation.fn) {
            return;
        }
        // 将参数对象转为数组
        var argList = argumentTransform(cancelOperation.arguments);
        cancelOperation.fn.apply(vm, argList);
    }

    // 拼接用于Sweet使用的配置
    function updateSweetCfg(sweetCfg, type, title, text) {
        sweetCfg.title = title;
        sweetCfg.type = type;
        sweetCfg.text = text;
    }

    function callbackManager(sweetCfg, confirmCallback, cancelCallback) {
        if (cancelCallback) {
            sweetCfg.showCancelButton = true;
            // 取消按钮颜色值
            if (cancelCallback.color) {
                sweetCfg.cancelButtonColor = cancelCallback.color;
            }
            if (cancelCallback.text) {
                sweetCfg.cancelButtonText = cancelButtonText.text;
            }
        }
        // 确认按钮颜色值
        if (confirmCallback && confirmCallback.color) {
            sweetCfg.confirmButtonColor = confirmCallback.color;
        }
        // 确认按钮文本
        if (confirmCallback && confirmCallback.text) {
            sweetCfg.confirmButtonText = confirmCallback.text;
        }
    }


    function infoPrompt(title, text, confirmCallback, cancelCallback, extendCfg) {
        var sweetCfg = extendCfg || angular.fromJson(angular.toJson(defaultSweetConfig));
        // 更新sweet配置
        updateSweetCfg(sweetCfg, 'info', title, text);
        // 设置确认及取消事件
        callSweetAlert(sweetCfg, confirmCallback, cancelCallback)
    }

    function warningPrompt(title, text, confirmCallback, cancelCallback, extendCfg) {
        var sweetCfg = extendCfg || angular.fromJson(angular.toJson(defaultSweetConfig));
        // 更新sweet配置
        updateSweetCfg(sweetCfg, 'warning', title, text);
        // 设置确认及取消事件
        callSweetAlert(sweetCfg, confirmCallback, cancelCallback)
    }

    function errorPrompt(title, text, confirmCallback, cancelCallback, extendCfg) {
        var sweetCfg = extendCfg || angular.fromJson(angular.toJson(defaultSweetConfig));
        // 更新sweet配置
        updateSweetCfg(sweetCfg, 'error', title, text);
        // 设置确认及取消事件
        callSweetAlert(sweetCfg, confirmCallback, cancelCallback)
    }

    function successPrompt(title, text, confirmCallback, cancelCallback, extendCfg) {
        var sweetCfg = extendCfg || angular.fromJson(angular.toJson(defaultSweetConfig));
        // 更新sweet配置
        updateSweetCfg(sweetCfg, 'success', title, text);
        // 设置确认及取消事件
        callSweetAlert(sweetCfg, confirmCallback, cancelCallback)
    }

    function questionPrompt(title, text, confirmCallback, cancelCallback, extendCfg) {
        var sweetCfg = extendCfg || angular.fromJson(angular.toJson(defaultSweetConfig));
        // 更新sweet配置
        updateSweetCfg(sweetCfg, 'question', title, text);
        // 控制是否显示取消按钮及设置取消回调
        callbackManager(sweetCfg, confirmCallback, cancelCallback);
        // 设置确认及取消事件
        callSweetAlert(sweetCfg, confirmCallback, cancelCallback)
    }

    function extendSweetAlertConfig(type, title, text, confirmCallback, cancelCallback) {
        var defaultCfg = angular.fromJson(angular.toJson(defaultSweetConfig));
    }

    // 通用调用方法
    function commomPrompt(type, title, text, confirmCallback, cancelCallback) {
        // 扩展用于sweetAlert的配置方法
        // var extendConfg = extendSweetAlertConfig(type, title, text, confirmCallback, cancelCallback);
        // 按类型调用提示方式
        window.qpAlertPrompt[type](title, text, confirmCallback, cancelCallback);
    }

    // 对外接口
    var qpAlertPrompt = {
        info: infoPrompt,
        warning: warningPrompt,
        error: errorPrompt,
        success: successPrompt,
        question: questionPrompt,
        prompt: commomPrompt
    }

    // 将对外接口挂载在window中
    if (typeof window !== 'undefined' && !window.qpAlertWidget) {
        window.qpAlertPrompt = qpAlertPrompt;
    }
}())